var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "q-form",
        { ref: "editForm" },
        [
          _c(
            "c-card",
            {
              staticClass: "cardClassDetailForm",
              attrs: { title: "LBLBASEINFO" },
            },
            [
              _c(
                "template",
                { slot: "card-button" },
                [
                  _c(
                    "q-btn-group",
                    { attrs: { outline: "" } },
                    [
                      _c("c-btn", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.editable && _vm.isOld,
                            expression: "editable&&isOld",
                          },
                        ],
                        attrs: { label: "LBLREMOVE", icon: "delete" },
                        on: { btnClicked: _vm.deleteInfo },
                      }),
                      _c("c-btn", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.editable,
                            expression: "editable",
                          },
                        ],
                        attrs: {
                          url: _vm.saveUrl,
                          isSubmit: _vm.isSave,
                          param: _vm.jobStressBrainCardiovascular,
                          mappingType: _vm.mappingType,
                          label: "LBLSAVE",
                          icon: "save",
                        },
                        on: {
                          beforeAction: _vm.saveInfo,
                          btnCallback: _vm.saveCallback,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("template", { slot: "card-detail" }, [
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6" },
                  [
                    _c("c-text", {
                      attrs: {
                        required: true,
                        editable: _vm.editable,
                        label: "제목",
                        name: "jobStressBrainCardiovascularName",
                      },
                      model: {
                        value:
                          _vm.jobStressBrainCardiovascular
                            .jobStressBrainCardiovascularName,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.jobStressBrainCardiovascular,
                            "jobStressBrainCardiovascularName",
                            $$v
                          )
                        },
                        expression:
                          "jobStressBrainCardiovascular.jobStressBrainCardiovascularName",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2",
                  },
                  [
                    _c("c-plant", {
                      attrs: {
                        required: true,
                        editable: _vm.editable,
                        type: "edit",
                        name: "plantCd",
                      },
                      model: {
                        value: _vm.jobStressBrainCardiovascular.plantCd,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.jobStressBrainCardiovascular,
                            "plantCd",
                            $$v
                          )
                        },
                        expression: "jobStressBrainCardiovascular.plantCd",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12" },
                  [
                    _c("c-textarea", {
                      attrs: {
                        editable: _vm.editable,
                        rows: 5,
                        label: "비고",
                        name: "remarks",
                      },
                      model: {
                        value: _vm.jobStressBrainCardiovascular.remarks,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.jobStressBrainCardiovascular,
                            "remarks",
                            $$v
                          )
                        },
                        expression: "jobStressBrainCardiovascular.remarks",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6",
                  },
                  [
                    _c("c-upload", {
                      attrs: {
                        attachInfo: _vm.attachJobStressInfo,
                        editable: _vm.editable,
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6",
                  },
                  [
                    _c("c-upload", {
                      attrs: {
                        attachInfo: _vm.attachBrainCardiovascularInfo,
                        editable: _vm.editable,
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }